import TekoID from 'teko-oauth2';
import { browserHistory, trackingHelpers } from 'helpers';

const { nonBlockTrackResponseTimeWrapper } = trackingHelpers;

const isLoggedIn = () => {
  return TekoID.user?.isLoggedIn();
};

const login = () => {
  TekoID.user?.login();
};

const logout = () => {
  // Tracking - Reset userId when logged out
  track('resetUserId');
  TekoID.user.logout(window.location.origin);
};

const getAccessToken = () => {
  return TekoID.user?.getAccessToken();
};

const loadUser = () => {
  return TekoID.user?.loadUser();
};

const unloadUser = () => {
  return TekoID.user?.unloadUser();
};

const getUserInfo = () => {
  return TekoID.user?.getUserInfo();
};

const getFullUserInfo = async (isOnlineMode = true) => {
  if (!isOnlineMode) {
    const { db } = await import('db');
    const localUsers = await db.currentUser.toArray();
    return localUsers[0];
  }

  return await nonBlockTrackResponseTimeWrapper(
    TekoID.user.getFullUserInfoWithCache(),
    'teko-id-getFullUserInfo'
  );
};

const denyAccess = () => {
  browserHistory.push('/403');
};

export default {
  isLoggedIn,
  login,
  logout,
  getAccessToken,
  getUserInfo,
  getFullUserInfo,
  denyAccess,
  loadUser,
  unloadUser,
};
